import { render } from "./VehicleInfoContent.vue?vue&type=template&id=75971217"
import script from "./VehicleInfoContent.vue?vue&type=script&lang=js"
export * from "./VehicleInfoContent.vue?vue&type=script&lang=js"

import "./VehicleInfoContent.vue?vue&type=style&index=0&id=75971217&lang=scss"

import exportComponent from "/var/local/jenkins-agent/data/agent/workspace/_Bitbucket_tvg-online-gui_master/tvg-online-ui/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__